module.exports = __webpack_public_path__ + "assets/37786f0242c523991e8953042a57ae8e.png";